module.exports = $;


//////////////////
// WEBPACK FOOTER
// external "$"
// module id = 124
// module chunks = 1 8 10 11 13 14 16 17 22 23 26 27 28 29 31 32 33 34 35 36 37 38 43 49